module.exports = __webpack_public_path__ + "static/media/save-contract-hubita.d6e10aae.gif";